import EditionsBagourd from "./EditionsBagourd";

function App() {
  return <EditionsBagourd />;
}

export default App;
